import type { FC, SVGProps } from 'react';

export const ArrowDownIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.2498 7.16691H12.8034C12.7212 7.16691 12.6427 7.20262 12.5873 7.26512L8.67838 11.7705V1.71512C8.67838 1.63655 8.6141 1.57227 8.53553 1.57227H7.4641C7.38553 1.57227 7.32124 1.63655 7.32124 1.71512V11.7705L3.41231 7.26512C3.35874 7.20262 3.28017 7.16691 3.19624 7.16691H1.74981C1.62838 7.16691 1.56231 7.31155 1.64267 7.40262L7.56946 14.233C7.62303 14.2948 7.68926 14.3444 7.76367 14.3783C7.83807 14.4123 7.91891 14.4299 8.00071 14.4299C8.0825 14.4299 8.16334 14.4123 8.23774 14.3783C8.31215 14.3444 8.37838 14.2948 8.43196 14.233L14.357 7.40262C14.4373 7.30977 14.3712 7.16691 14.2498 7.16691Z"
    />
  </svg>
);
